export interface IBasePage {
    name: string;
    path: string;
    icon: string;
    router: string;
    onlyShowIfLocationContextIsValid: boolean; // Only show if Location Context is valid
    onlyShowIfLocationContextIsNotValid: boolean; // Only show if Location Context is NOT valid
    restrictionKey: string;
}

export interface IPages {
    login: IBasePage;
    locationContext: IBasePage;
    locationContext_Terminal: IBasePage;
    locationContext_CenterlineGroup: IBasePage;
    locationContext_Centerline: IBasePage;
    flights: IBasePage;
    docking: IBasePage;
    profile: IBasePage;
    maintenance: IBasePage;
    statistics: IBasePage;
    eventLogs: IBasePage;
    errorLogs: IBasePage;
}

export const Pages: IPages = {
    login: {
        name: 'Login',
        path: 'login',
        icon: '',
        router: '/login',
        onlyShowIfLocationContextIsValid: false,
        onlyShowIfLocationContextIsNotValid: false,
        restrictionKey: ''
    },
    locationContext: {
        name: 'Location Context',
        path: 'context',
        icon: 'location_on',
        router: '/context',
        onlyShowIfLocationContextIsValid: false,
        onlyShowIfLocationContextIsNotValid: true,
        restrictionKey: ''
    },
    //eslint-disable-next-line @typescript-eslint/naming-convention
    locationContext_Terminal: {
        name: 'Location Context Terminal',
        path: 'terminal',
        icon: '',
        router: '/terminal',
        onlyShowIfLocationContextIsValid: false,
        onlyShowIfLocationContextIsNotValid: true,
        restrictionKey: ''
    },
    //eslint-disable-next-line @typescript-eslint/naming-convention
    locationContext_CenterlineGroup: {
        name: 'Location Context Centerline Group',
        path: 'group',
        icon: '',
        router: '/group',
        onlyShowIfLocationContextIsValid: false,
        onlyShowIfLocationContextIsNotValid: true,
        restrictionKey: ''
    },
    //eslint-disable-next-line @typescript-eslint/naming-convention
    locationContext_Centerline: {
        name: 'Location Context Centerline',
        path: 'centerline',
        icon: '',
        router: '/centerline',
        onlyShowIfLocationContextIsValid: false,
        onlyShowIfLocationContextIsNotValid: true,
        restrictionKey: ''
    },
    flights: {
        name: 'Flights',
        path: 'flights',
        icon: 'flight_land',
        router: '/flights',
        onlyShowIfLocationContextIsValid: true,
        onlyShowIfLocationContextIsNotValid: false,
        restrictionKey: 'flights'
    },
    docking: {
        name: 'Safedock',
        path: 'safedock',
        icon: 'flight',
        router: '/safedock',
        onlyShowIfLocationContextIsValid: true,
        onlyShowIfLocationContextIsNotValid: false,
        restrictionKey: 'safedock'
    },
    profile: {
        name: 'Profile',
        path: 'profile',
        icon: 'person',
        router: '/profile',
        onlyShowIfLocationContextIsValid: false,
        onlyShowIfLocationContextIsNotValid: false,
        restrictionKey: ''
    },
    maintenance: {
        name: 'Maintenance',
        path: 'maintenance',
        icon: 'build',
        router: '/maintenance',
        onlyShowIfLocationContextIsValid: true,
        onlyShowIfLocationContextIsNotValid: false,
        restrictionKey: 'maintenance'
    },
    statistics: {
        name: 'Statistics',
        path: 'statistics',
        icon: 'straighten',
        router: '/statistics',
        onlyShowIfLocationContextIsValid: true,
        onlyShowIfLocationContextIsNotValid: false,
        restrictionKey: 'statistics'
    },
    eventLogs: {
        name: 'Event Logs',
        path: 'event-logs',
        icon: 'folder',
        router: '/event-logs',
        onlyShowIfLocationContextIsValid: true,
        onlyShowIfLocationContextIsNotValid: false,
        restrictionKey: 'event_logs'
    },
    errorLogs: {
        name: 'Error Logs',
        path: 'error-logs',
        icon: 'error',
        router: '/error-logs',
        onlyShowIfLocationContextIsValid: true,
        onlyShowIfLocationContextIsNotValid: false,
        restrictionKey: 'error_logs'
    }
};
